/**
 * Heuristic for crawlers / preview bots. Used for PWA SW registration and RUM filtering.
 * Tune the pattern if legitimate traffic is misclassified.
 */
const BOT_USER_AGENT_RE =
  /bot|crawl|spider|slurp|bingpreview|mediapartners|adsbot|googlebot|duckduckbot|facebot|ia_archiver|google-read-aloud|pageburst|semrush|ahrefs|petalbot|bytespider/i;

export function isLikelyAutomatedUserAgent(userAgent: string): boolean {
  return BOT_USER_AGENT_RE.test(userAgent);
}
